import { environment } from "../../../environments/environment";
import { FETCH_METHODS, SearchConfig } from "./api.model";
import { DataTableSchema, DefaultTableSchema, TableColumnSchema } from "./dynamic-data-table.model";
import { SpinIdNumber, defaultSearchContainerButtons, EventDealerDropdown, AreaMutipleSelect, EventBillingEventDropdown, EventBillingYearDropdown, StatusDropdown } from "./form-fields.model";
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from "./form.model";

export const EventBillingBaseUrl = () => {
    return environment['eventBilling'] ?? 'eventBilling';
};

const FormFieldArray: FormFieldConfig[] = structuredClone([ EventBillingEventDropdown,EventBillingYearDropdown,AreaMutipleSelect,SpinIdNumber,
    EventDealerDropdown,StatusDropdown ])
const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

export const EventBillingSearchConfig: SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: 'billingReportSearch',
    body:
    {
        "spinId": "",
        "year": "",
        "event": "",
        "dealerNumber": "",
        "area": [],
        "status":""
    }
}
const columnSchema:TableColumnSchema[] = [
        { label: 'Spin ID', fieldKey: 'spinid' },
        { label: 'Dealer', fieldKey: 'organisation'},
        { label: 'Name', fieldKey: 'name' },
        { label: 'Area', fieldKey: 'areaname' },
        { label: 'Start Date', fieldKey: 'start_date' },
        { label: 'Completion Date', fieldKey: 'completion_date' },
        { label: 'Status', fieldKey: 'status' },
        { label: 'Amount($)', fieldKey: 'amount' }
    ];


export const EventBillingReportTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: columnSchema,
    exportConfig: {
        fileName: 'Event_Billing',
        exportMessage: "Event Billing Report Data",
        schema: {
            spinid: "SPIN ID",
            organisation: "DEALER",
            name: "NAME",
            areaname:'Area',
            start_date: "START DATE",
            completion_date: "COMPLETION DATE",
            status: "STATUS",
            amount: "AMOUNT($)",
        }
    }
};

export const EventBillingReportFormArray: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: EventBillingSearchConfig,
    autoSearchOnLoad: false
};

export const EventBillingReportProps: Props = {
    isSearchVisible: true,
    isTabStretch: true
};
